import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[onlyNumber]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OnlyNumberDirective),
      multi: true
    }
  ]
})
export class OnlyNumberDirective implements ControlValueAccessor {

  public onChangeCallback = (_: any) => { };
  @HostListener('blur', ['$event'])
  public onTouchCallback = () => { };

  constructor(private _elementRef: ElementRef) { }

  @HostListener('input')
  onInput(): void {
    const cleanValue: string = this._cleanValue(this._elementRef.nativeElement.value);
    this._elementRef.nativeElement.value = cleanValue;
    this.onChangeCallback(cleanValue);
  }

  public writeValue(modelValue: string): void {
    if (modelValue === null || modelValue === undefined) {
      this._elementRef.nativeElement.value = '';
      return;
    }

    this._elementRef.nativeElement.value = this._cleanValue(String(modelValue));
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchCallback = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this._elementRef.nativeElement.disabled = isDisabled;
  }

  public _cleanValue(viewValue: string): string {
    return viewValue.replace(/[^\d]/g, '');
  }

}
